// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__v7ct_","info":"PatientInfo_info__MTOyh"};